var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWebIntIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.8332 16.9993C32.8332 25.7439 25.7443 32.8327 16.9998 32.8327M32.8332 16.9993C32.8332 8.25484 25.7443 1.16602 16.9998 1.16602M32.8332 16.9993H1.1665M16.9998 32.8327C8.25533 32.8327 1.1665 25.7439 1.1665 16.9993M16.9998 32.8327C12.9342 28.5638 10.6665 22.8945 10.6665 16.9993C10.6665 11.1042 12.9342 5.43493 16.9998 1.16602M16.9998 32.8327C21.0655 28.5638 23.3332 22.8945 23.3332 16.9993C23.3332 11.1042 21.0655 5.43493 16.9998 1.16602M1.1665 16.9993C1.1665 8.25484 8.25533 1.16602 16.9998 1.16602",
    stroke: "#1764D1",
    strokeWidth: 2.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebIntIcon);
export default __webpack_public_path__ + "static/media/web_int_icon.3102a0c64b4cf96d864cf89da4824882.svg";
export { ForwardRef as ReactComponent };